import React from 'react';
import PropTypes from 'prop-types';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import atbat from '../store/reducers/atbat';
import AtBatPlay from '../AtBatPlay';
import playMetricsDataSource from '@gameday/core/datasources/playMetrics';
import contentGraphDataSource from '@gameday/core/datasources/contentGraph';
import contentDataSource from '@gameday/core/datasources/content';
import atBatDataRequestAction from '../store/actions/atBatDataRequestAction';
import { routes as atBatPitchFxRoutes } from '../containers/AtBatPitchFxDataContainer';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';

const fetchData = () => {
    return atBatDataRequestAction();
};

initContainerData.register({
    datasources: {
        content: contentDataSource,
        contentGraph: contentGraphDataSource,
        playMetrics: playMetricsDataSource
    },
    reducers: {
        atbat
    }
});
const routes = [{
    path: '/',
    exact: false,
    fetchData,
    routes: [...atBatPitchFxRoutes]
}];

const AtBatDataContainer = ({
    playIndex
}) => {
    return (
        <ErrorBoundaryWrapper componentName='Play Detail'>
            {typeof playIndex !== 'undefined' ? <AtBatPlay playIndex={playIndex} /> : null}
        </ErrorBoundaryWrapper>
    );
};

AtBatDataContainer.propTypes = {
    playIndex: PropTypes.number
};

export default AtBatDataContainer;
export { fetchData, routes };
